import React from 'react';
import styled from 'styled-components';

import Separator from './separator';
import { translate } from '~/services/translate';
import { FlexCentered } from '~/components/basic/containers';

const SeparatorContainer = styled(FlexCentered)`
  margin-bottom: 16px;
  margin-top: 8px;
  justify-content: center;
`;

const StyledSeparator = styled(Separator)`
  max-width: 150px;
`;

const OrContainer = styled.div`
  display: flex;
  height: 40px;
  min-width: 40px;
`;

const OrText = styled.div`
  display: flex;
  margin: auto;
  font-weight: 600;
  font-size: 13px;
  color: ${({ theme }) => theme.lightGray};
`;

export default () => (
  <SeparatorContainer>
    <StyledSeparator />
    <OrContainer>
      <OrText>{translate('or').toUpperCase()}</OrText>
    </OrContainer>
    <StyledSeparator />
  </SeparatorContainer>
)